import fetch from '@/apiconfig/index';

//发布需求获取地区  
export function getAllCity() {
    return fetch({
        url: 'api/admin/area/getAllCity',
        method: 'get'
    });
}

//未登陆任务大厅  
export function pageByMobile(jquery) {
    return fetch({
        url: 'api/contract/taskController/pageByMobile',
        method: 'get',
        params: jquery
    });
}
//已登陆任务大厅  
export function pageByUserMobile(jquery) {
    return fetch({
        url: 'api/contract/taskController/pageByUserMobileNew',
        method: 'get',
        params: jquery
    });
}

//任务详情 
export function getByMobile(jquery) {
    return fetch({
        url: 'api/contract/taskController/getByMobile',
        method: 'get',
        params: jquery
    });
}

//新增任务申请  
export function addTaskApply(data) {
    return fetch({
        url: 'api/contract/taskController/addTaskApply',
        method: 'post',
        data: data
    });
}

// 我的任务
export function pageByEmployee(jquery) {
    return fetch({
        url: 'api/contract/taskController/pageByEmployee',
        method: 'get',
        params: jquery
    });
}

// 我的任务明细
export function getByEmployee(jquery) {
    return fetch({
        url: 'api/contract/taskController/getByEmployee',
        method: 'get',
        params: jquery
    });
}

// 所有任务类型
export function select() {
    return fetch({
        url: 'api/companystaff/ecompanyJobCategory/select',
        method: 'get'
    });
}

// 我的任务类型
export function selectByAccount() {
    return fetch({
        url: 'api/companystaff/ecompanyJobCategory/selectByAccount',
        method: 'get'
    });
}

// 交付
export function addTaskSubmit(data) {
    return fetch({
        url: 'api/contract/taskController/addTaskSubmit',
        method: 'post',
        data: data
    });
}

// 注册
export function register(data) {
    return fetch({
        url: 'api/companystaff/employeeAccount/register',
        method: 'post',
        data: data
    });
}

// 查询证件号是否存在
export function checkIdNumber(id) {
    return fetch({
        url: 'api/companystaff/employeeAccount/check/' + id + '/idNumber',
        method: 'get'
    });
}

// 查询证件号是否存在
export function checkMobile(id) {
    return fetch({
        url: 'api/companystaff/employeeAccount/check/' + id + '/mobile',
        method: 'get'
    });
}

// 获取任务交付记录
export function getSubmitByEmployee(params) {
    return fetch({
        url: 'api/contract/taskController/getSubmitByEmployee',
        method: 'get',
        params: params
    });
}